import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

/**
 * This loader does not copy empty translations making it possible to
 * present the default language text instead an empty string.
 * https://github.com/ngx-translate/core/issues/662
 */
export class PruningTranslationLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly prefix: string,
    private readonly suffix: string,
  ) {}

  public getTranslation(lang: string): any {
    return this.http
      .get(`${this.prefix}${lang}${this.suffix}`)
      .pipe(map((res: object) => this.process(res)));
  }

  private process(object: any): any {
    const newObject = {};
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        this.copy(key, object, newObject);
      }
    }
    return newObject;
  }

  private copy(key: string, object: any, newObject: any): void {
    if (typeof object[key] === 'object') {
      newObject[key] = this.process(object[key]);
    } else if (typeof object[key] === 'string' && object[key] === '') {
      // TODO: Specify how to handle empty strings
      // Currently do not copy empty strings
    } else {
      newObject[key] = object[key];
    }
  }
}

// Required for AOT compilation
export const httpLoaderFactory = (http: HttpClient): TranslateLoader => {
  return new PruningTranslationLoader(http, './assets/locale/', '.json');
};
